angular.module('app')
.config(function($stateProvider) {
  $stateProvider
    .state('index',{
      url: '/',
      templateUrl: '../views/main.html',
      controller: 'mainController'
    });
})
.controller('mainController', function($scope, storageFactory, picsFactory, $uibModal, angularGridInstance, ngToast, $state){

  $scope.start = true;
  $scope.volunteers = [];
  $scope.pics = [];

  picsFactory.getPics(function(data){
    $scope.pics = data;
  });

  $scope.learn = function(){
    $state.go('learn');
  };

  $scope.animationsEnabled = true;
  $scope.open = function (size) {
    var modalInstance = $uibModal.open({ // jshint ignore:line
      animation: $scope.animationsEnabled,
      templateUrl: 'myModalContent.html',
      controller: 'ModalInstanceCtrl',
      size: size,
      resolve: {}
    });
  };

  $scope.newEmail = function(){
      storageFactory.addEmails($scope.emailList, function(data){
        $scope.emails = data;
        $scope.emailList = {};
        $scope.beInKnow.$setPristine();
        ngToast.create({
           className: 'success',
           content: '<a>Your Email has been Saved!</a>'
         });
      });
  };

});

// -----------Modal Controller------------

angular.module('app')
.controller('ModalInstanceCtrl', function ($scope, $uibModalInstance, storageFactory, ngToast) {

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.newVol = function(){
    $scope.volunteerForm.createdAt = new Date();
    storageFactory.addVolunteer($scope.volunteerForm, function(data){
      if(data){
        ngToast.create({
           className: 'success',
           content: '<a>Your Information has been Saved!</a>'
         });
        $scope.volunteers = data;
        $scope.volunteerForm = {};
        // $scope.submitted = true;
        $scope.volunteer.$setPristine();
        $uibModalInstance.dismiss('cancel');
      }
    });
  };

});
